import { FileTypes } from '../../../enums/fileTypes';

export const SHAPEFILE_EXTENSIONS: ReadonlySet<string> = new Set(['.shp', '.dbf', '.shx', '.prj']);

const extensionFileTypes: Record<string, FileTypes> = {
  '.shp': FileTypes.SHAPEFILE,
  '.dbf': FileTypes.SHAPEFILE,
  '.shx': FileTypes.SHAPEFILE,
  '.prj': FileTypes.SHAPEFILE,
  '.geojson': FileTypes.GEOJSON,
  '.kml': FileTypes.KML,
  '.kmz': FileTypes.KMZ,
  '.tif': FileTypes.RASTER,
  '.tiff': FileTypes.RASTER,
};

export const fileTypeForExtension = (extension: string): FileTypes | undefined => extensionFileTypes[extension.toLowerCase()];

export const extensionOf = (name: string): string => {
  const index = name.lastIndexOf('.');
  return index < 0 ? '' : name.slice(index).toLowerCase();
};

export const baseNameOf = (name: string): string => {
  const index = name.lastIndexOf('.');
  return index < 0 ? name : name.slice(0, index);
};
